/**
 * Contains camio api calls.
 * @module api/auth
 */

import Settings from '../settings';

/**
 * @typedef {Object} User
 * @property {number} userId UserId of the user
 * @property {string} userName User name
 */

/**
 * @typedef {Object} AuthenticatedResponse
 * @property {boolean} authenticated True if there is a user authenticated
 * @property {module:api/auth~User} user The authenticated user
 */

const serverPath = Settings.serverPath;

/**
 * Begins a user session with the supplied username
 * @func login
 * @param  {string} username The username to login with.
 * @return {Promise<boolean>} True if the login was successful.
 */
// eslint-disable-next-line
export const login = (username) => fetch(`${serverPath}UserSessionHandler.ashx${username ? `?UserName=${username}` : ''}`, {
  method: 'get',
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'include'
}).then(response => Promise.resolve(response.json())
).catch(error => Promise.reject(`login failed: ${error}`));



// WEBPACK FOOTER //
// ./app/api/auth.js